import React from "react";
import "./welcome-page.scss";

type WelcomePageProps = {
  SurveyFormTitle?: string;
  SurveyFromInstructions?: string;

  setWelcomePageDemo?: React.Dispatch<React.SetStateAction<boolean>>;
  formType?:number
};

const WelcomePage: React.FC<WelcomePageProps> = ({
  SurveyFormTitle,
  SurveyFromInstructions,
  setWelcomePageDemo,
  formType
}) => {
  const handleStartClick = () => {
    if (setWelcomePageDemo) {
      setWelcomePageDemo(true);
    }
  };

  return (
    <div className="welcome-page text-center">
      <h1>Welcome to your {formType === 2 ? "Quiz" : "Survey"}</h1>
      <p className="form-title"> {SurveyFormTitle}</p>
      <p> {SurveyFromInstructions}</p>
      <p className="mt-2"><i>We are glad you're here. Click "Start" to continue</i></p>
      <button onClick={handleStartClick} className="submit-btn">Start</button>
    </div>
  );
};

export default WelcomePage;
